"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var ClassesApi = /** @class */ (function () {
    function ClassesApi(axiosInstance) {
        var _this = this;
        this.getClass = function (id) { return _this.instance.get("/api/classes/" + id); };
        this.instance = axiosInstance || axios_1.default;
    }
    return ClassesApi;
}());
exports.default = ClassesApi;
